module.exports = __webpack_public_path__ + "static/media/congo-сash.79500533.gif";